import Vue from "vue";
import VueRouter from "vue-router";
import VueGtag from 'vue-gtag'

Vue.use(VueRouter);
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const routes = [{
  path: "/",
  name: "Home",
  component: () => import( /* webpackChunkName: "home" */ "../views/Home/home.vue"),
  meta: {
    title: 'Buy eSIM Online - Global eSIMs for Sale at eSimart.com'
  }
},{
  path: "/tf",
  name: "tf",
  component: () => import( /* webpackChunkName: "home" */ "../views/Home/home.vue"),
  meta: {
    title: 'Buy eSIM Online - Global eSIMs for Sale at eSimart.com'
  }
},
  {
    path: "/details",
    name: "Details",
    component: () => import( /* webpackChunkName: "details" */ "../views/Product/details.vue"),
    meta: {
      // title: '產品詳情'
    }
  },
  {
    path: "/product",
    name: "Product",
    component: () => import( /* webpackChunkName: "details" */ "../views/Product/list.vue"),
    meta: {
      title: 'eSIM product - eSImart'
    }
  },
  {
    path: "/search",
    name: "Search",
    component: () => import( /* webpackChunkName: "details" */ "../views/Search/search.vue"),
    meta: {
      title: 'Search your eSIM - eSImart'
    }
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import( /* webpackChunkName: "details" */ "../views/Cart/cart.vue"),
    meta: {
      title: 'Shopping cart - eSImart',
      requireAuth: false
    }
  },
  {
    path: "/closing",
    name: "Closing",
    component: () => import( /* webpackChunkName: "details" */ "../views/Cart/closing.vue"),
    meta: {
      title: 'Payment - eSImart',
      requireAuth: false
    }
  },
  {
    path: "/test",
    name: "test",
    component: () => import( /* webpackChunkName: "details" */ "../views/test.vue"),
    meta: {
      title: '結帳',
      requireAuth: false
    }
  },
  {
    path: "/paymentResult",
    name: "paymentResult",
    component: () => import( /* webpackChunkName: "details" */ "../views/Cart/paymentResult.vue"),
    meta: {
      title: 'paymentResult - eSImart',
      requireAuth: false
    }
  },
  {
    path: "/personal",
    name: "Personal",
    component: () => import( /* webpackChunkName: "details" */ "../views/Personal/personal.vue"),
    meta: {
      title: 'Personal - eSImart',
      requireAuth: true
    }
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import( /* webpackChunkName: "details" */ "../views/About/privacy.vue"),
    meta: {
      title: 'eSIM privacy policy - eSImart'
    }
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import( /* webpackChunkName: "details" */ "../views/About/terms.vue"),
    meta: {
      title: 'Terms and Conditions - eSImart'
    }
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: () => import( /* webpackChunkName: "details" */ "../views/About/contactUs.vue"),
    meta: {
      title: 'Contact Us - eSImart'
    }
  },
  {
    path: "/tutorial",
    name: "tutorial",
    component: () => import( /* webpackChunkName: "details" */ "../views/Support/tutorial.vue"),
    meta: {
      title: 'eSIM installation tutorial - eSImart'
    }
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import( /* webpackChunkName: "details" */ "../views/Support/faq.vue"),
    meta: {
      title: 'Frequency ask question - eSImart'
    }
  },
  // {
  //   path: "/tutorial",
  //   name: "tutorial",
  //   component: () => import(/* webpackChunkName: "details" */ "../views/Tutorial/tutorial.vue"),
  //   meta: {
  //     title: 'Tutorial'
  //   }
  // },
  // {
  //   path: "/contactus",
  //   name: "contactus",
  //   component: () => import(/* webpackChunkName: "details" */ "../views/contactUs/index.vue"),
  //   meta: {
  //     title: 'Contactus'
  //   }
  // },
  {
    path: "/helpCenter",
    name: "helpCenter",
    component: () => import( /* webpackChunkName: "details" */ "../views/helpCenter/index.vue"),
    meta: {
      title: 'HelpCenter - eSImart'
    }
  },
  {
    path: "/works",
    name: "works",
    component: () => import( /* webpackChunkName: "details" */ "../views/works.vue"),
    meta: {
      title: 'How to install your esim card - eSImart'
    }
  },
  {
    path: "/affiliate",
    name: "affiliate",
    component: () => import( /* webpackChunkName: "details" */ "../views/affiliate.vue"),
    meta: {
      title: 'Welcome to the future of connectivity - eSImart'
    }
  },
  {
    path: "/affiliateSign",
    name: "affiliateSign",
    component: () => import( /* webpackChunkName: "details" */ "../views/affiliateSign.vue"),
    meta: {
      title: 'Register as Affiliate - eSImart'
    }
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import( /* webpackChunkName: "details" */ "../views/aboutUs.vue"),
    meta: {
      title: 'about us - eSImart'
    }
  },

  {
    path: '/404',
    name:'404',
    component: () => import("../views/blank/index.vue"),
    hidden: true
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
];

const router = new VueRouter({
  mode: "history",
  base: './',
  routes,
  // 切换路由后滚动条置顶
  scrollBehavior() {
    return {
      x: 0,
      y: 0
    }
  }
});
router.beforeEach((to, from, next) => {
  // if (window.gtag) {
  //   // console.log('window.gtag',window.gtag)
  //   // console.log('to.fullPath',to.fullPath)
  //   window.gtag('config', 'G-9D7WEGV5T7', { 'page_path': to.fullPath});
  // }
  next();
})
export default router;
